module.exports = __webpack_public_path__ + "img/creature_bg.a00796be.svg";